import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import History from '@/js/plugins/CookieDb/History';
import { authCheck, zeroPadding, isPc } from '@/js/helpers';
import Favorite from '@/js/plugins/CookieDb/Favorite';
import SmoothScroll from 'smooth-scroll';
import GalleryModal from '@/js/plugins/GalleryModal';
import Modal from '@/js/plugins/Modal';
import { Viewer } from '@photo-sphere-viewer/core';
import "@photo-sphere-viewer/core/index.css";

// サムネイルのもっと見る表示制御
const renderThumbnailAction = () => {
    let showAll = false;
    const thumbnailLength = $('.pg-gallery-thumbnails__item').not('[data-more]').length;
    if (isPc()) {
        if (thumbnailLength > 8) {
            showAll = true;
        }
    } else {
        if (thumbnailLength > 10) {
            showAll = true;
        }
    }
    if (showAll) {
        $('.pg-gallery-thumbnails__item[data-more]').on('click', (e) => {
            $('.pg-gallery-thumbnails__list').attr('data-render-no-limit', '');
        });
    }
}

// 画像のロード完了を待つ
const initImagesLoad = async (selector) => {
    const slider = document.querySelector(selector);
    const images = Array.from(slider.querySelectorAll('img'));

    // 画像ロードを Promise でラップ
    const loadPromises = images.map(img => {
        return new Promise(resolve => {
            if (img.complete) {
                resolve(); // すでにロード済み
            } else {
                img.addEventListener('load', resolve);
                img.addEventListener('error', resolve); // 失敗でも解決して次へ
            }
        });
    });

    return await Promise.all(loadPromises);
}

// ギャラリーのアクション設定
const setGalleryAction = async () => {
    renderThumbnailAction()
    let slideAllCount = 0;

    await initImagesLoad('.js-gallery-slider')
    .then(() => {
        const $slider = $(".js-gallery-slider");
        const slideCount = $slider.find('.slick-slide').length || $slider.children().length;

        // 1枚の場合は初期化しない
        if (slideCount <= 1) {
            $('.pg-gallery__pagination').text(`1 / 1`);
            return;
        }

        // スライダーアクション
        $slider.on('init', (event, slick) => {
            slideAllCount = slick.slideCount;
            $('.pg-gallery__pagination').text(`1 / ${slideAllCount}`);
        })
        .slick({
            fade: true,
            slidesToShow: 1,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 5000,
            infinite: true,
            arrows: false,
            // SPは矢印ではなくスワイプ操作のため、指の動きに追従するスライド表示にする
            // （fade時はslickのswipeMoveが動作せず、指に追従しないため）
            responsive: [
                {
                    breakpoint: 641,
                    settings: {
                        fade: false,
                        speed: 400,
                        touchThreshold: 10,
                        swipeToSlide: true,
                    },
                },
            ],
        })
        .on('afterChange', (event, slick, currentSlide) => {
            $('.pg-gallery__pagination').text(`${currentSlide + 1} / ${slideAllCount}`);
        });

        // カスタムナビゲーション
        const prevBtn = document.querySelector('.pg-gallery__nav-prev');
        const nextBtn = document.querySelector('.pg-gallery__nav-next');
        if (prevBtn) {
            prevBtn.addEventListener('click', () => $slider.slick('slickPrev'));
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', () => $slider.slick('slickNext'));
        }
    });
}

// スライドのページ切り替え
$('.pg-gallery-thumbnails__item').not('[data-more]').on('click', (e) => {
    const index = $(e.currentTarget).index()
    $(".js-gallery-slider").slick('slickGoTo', index)
})

// 物件詳細の追加表示（SP）
const showPropertyDetail = () => {
    $('.pg-estate-detail__more a').on('click', (e) => {
        $('.pg-estate-detail').addClass('is-open');
    })
}

const setFavoriteAction = async (pageId) => {
    const targetObjs = document.querySelectorAll('[data-type="favorite"]');
    const favorite = new Favorite();
    const targetDb = authCheck() ? 'db' : 'cookie';
    const changeFavoriteState = (target, newState) => {
        if (newState) {
            target.dataset.active = '';
        } else {
            delete target.dataset.active;
        }
        document.querySelectorAll('[data-favorite-count]').forEach((targetObj) => {
            const baseCount = targetObj.dataset.count ? Number(targetObj.dataset.count) : 0;
            const count = newState ? baseCount + 1 : baseCount - 1;
            targetObj.textContent = count < 99 ? count : '99+';
            targetObj.dataset.count = count;
        });
        document.querySelectorAll(`[data-type="favorite"][data-id="${pageId}"], .c-buttons-favorite[data-id="${pageId}"]`).forEach((targetObj) => {
            if (newState) {
                targetObj.dataset.active = '';
            }
            else {
                delete targetObj.dataset.active;
            }
        });
    }

    targetObjs.forEach((obj) => {
        obj.addEventListener('click', async (e) => {
            const isFavorite = e.currentTarget.hasAttribute('data-active');
            changeFavoriteState(e.currentTarget, !isFavorite);

            const resp = await favorite.setState(targetDb, pageId, !isFavorite)
            if (!resp) {
                changeFavoriteState(e.currentTarget, isFavorite);
            }
        })
    })
}

const setOpenHouseAction = () => {
    if (document.querySelector('.pg-tour-body') === null) return;
    document.querySelector('.pg-tour-body__more').addEventListener('click', (e) => {
        document.querySelector('.pg-tour__body').dataset.open = '';
    });
    // コンテンツの縦サイズが親の高さを超えていたら「もっと見る」ボタンを表示
    const tourBody = document.querySelector('.pg-tour__body');
    console.log(tourBody.scrollHeight, tourBody.clientHeight)
    if (tourBody.scrollHeight > tourBody.clientHeight) {
        document.querySelector('.pg-tour__body').dataset.more = '';
    }
}

const setOpenHouseBodyAction = () => {
    const openHouseBody = document.querySelector('.pg-open-house__body');
    if (openHouseBody === null) return;
    // コンテンツの縦サイズがmax-heightを超えていたら「もっと見る」ボタンを表示
    if (openHouseBody.scrollHeight > openHouseBody.clientHeight) {
        openHouseBody.dataset.more = '';
    }
    document.querySelector('.pg-open-house-body__more').addEventListener('click', () => {
        openHouseBody.dataset.open = '';
        delete openHouseBody.dataset.more;
    });
}

// 360度画像の表示
export const set360Image = () => {
    if(!document.querySelector('.pg-panorama')) return;
    const firstItem = document.querySelector('.pg-panorama__item');
    const viewer = new Viewer({
        container: document.querySelector('.pg-panorama__viewer'),
        panorama: firstItem.dataset.url || '',
        defaultZoomLvl: 0, // いちばんズームアウト
    });

    document.querySelectorAll('.pg-panorama__item').forEach(item => {
        item.addEventListener('click', (e) => {
            const url = e.currentTarget.dataset.url;
            viewer.setPanorama(url);

            // クリックされたアイテムをアクティブにする
            document.querySelectorAll('.pg-panorama__item').forEach(el => {
                delete el.dataset.active;
            });
            e.currentTarget.dataset.active = '';
        });
    });
    document.querySelector('.pg-panorama__item').dataset.active = '';
}


/**
 * pg-nav スクロール制御（SP のみ）
 * 下スクロール: data-hidden を付与して非表示
 * 上スクロール: data-hidden を除去して表示
 */
const BP_SM = 640; // @include sm の閾値

const setNavScroll = () => {
    const nav = document.querySelector('.pg-nav');
    if (!nav) return;

    const mq = window.matchMedia(`(max-width: ${BP_SM}px)`);
    let lastY = window.scrollY;

    const onScroll = () => {
        if (!mq.matches) return;

        const currentY = window.scrollY;
        const isAtTop = currentY === 0;
        const isScrollingDown = currentY > lastY && currentY > nav.offsetHeight;

        nav.toggleAttribute('data-hidden', !isAtTop && isScrollingDown);
        lastY = currentY;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
};

const setNavScrollSpy = () => {
    const navItems = document.querySelectorAll('.pg-nav__item');
    if (!navItems.length) return;

    const nav = document.querySelector('.pg-nav');
    const header = document.querySelector('.l-header');

    const sections = [];
    navItems.forEach(item => {
        const a = item.querySelector('a[href^="#"]');
        if (!a) return;
        const id = a.getAttribute('href').slice(1);
        const section = document.getElementById(id);
        if (section) sections.push({ navItem: item, section });
    });

    if (!sections.length) return;

    const update = () => {
        const headerH = header ? header.offsetHeight : 0;
        const navH = nav ? nav.offsetHeight : 0;
        const threshold = headerH + navH;

        let active = sections[0];
        for (const s of sections) {
            if (s.section.getBoundingClientRect().top <= threshold) {
                active = s;
            }
        }

        navItems.forEach(item => delete item.dataset.active);
        active.navItem.dataset.active = '';

        const newHash = '#' + active.section.id;
        if (location.hash !== newHash) {
            history.replaceState(null, '', newHash);
        }
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
};

const main = async () => {
    if (!document.querySelector('#page-estate-detail') && !document.querySelector('#page-rich')) return;
    const history = new History();
    const images = JSON.parse(document.querySelector('input[name="gallery_images"]').getAttribute('value'));
    const galleryModal = new GalleryModal({
        overlayClose: true,
        imgList: images.map((img) => {
            return {
                src: img.imagePath,
                alt: img.comment,
            }
        }),
    });
    const modal = new Modal;

    const pageId = document.querySelector('main').dataset.id;
    if (pageId.match(/^[0-9]+$/)) {
        // 閲覧履歴の記録
        history.setState(authCheck() ? 'db' : 'cookie', pageId, true)
    }

    // クリックした画像をモーダル表示
    document.querySelectorAll('.pg-gallery__main-slider img').forEach((img, index) => {
        img.addEventListener('click', (e) => {
            galleryModal.show(index)
        })
    });

    document.querySelectorAll('.pg-gallery-thumbnails__list img').forEach((img, index) => {
        img.addEventListener('click', (e) => {
            // galleryModal.show(index)
        })
    });
    // if (document.querySelector('.pg-gallery .c-buttons-default')) {
    //     document.querySelector('.pg-gallery .c-buttons-default').addEventListener('click', (e) => {
    //         e.preventDefault();
    //         galleryModal.show(0)
    //     });
    // }
    if (document.querySelectorAll('.pg-gallery__content .pg-gallery__all-view')) {
        document.querySelectorAll('.pg-gallery__content .pg-gallery__all-view').forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                galleryModal.show(0)
            });
        });
    }

    document.querySelectorAll('[data-modal-image]').forEach((obj) => {
        obj.addEventListener('click', (e) => {
            const img = document.createElement('img');
            img.src = e.currentTarget.dataset.modalImage;
            const dom = document.createElement('div');
            dom.classList.add('img');
            dom.appendChild(img);
            modal.setDom(dom).show();
        });
    });

    // 戻るボタン
    $('.pg-fix-content__item--back a, .pg-back a').on('click', (e) => {
        e.preventDefault();
        window.history.back();
    });

    new SmoothScroll('a[href*="#"]', {
        speed: 300,
        header: '.l-header',
        speedAsDuration: true,
        easing: 'linear',
    });

    setOpenHouseAction();
    setOpenHouseBodyAction();
    showPropertyDetail();
    setGalleryAction();
    setFavoriteAction(pageId);
    set360Image();
    setNavScroll();
    setNavScrollSpy();
}

export default main;
